import { SearchQuery } from '@elevio-kb/queries/dist/types';
import { createAction, ActionsUnion } from '../utils/types';
import { SearchStyle } from '../Config';

export enum ActionTypes {
  SEARCH_REQUEST = 'search::request',
  SEARCH_FETCH_STARTED = 'search::fetch_started',
  SEARCH_SUCCESS = 'search::success',
  SEARCH_FAIL = 'search::fail',
  SEARCH_CANCEL = 'search::cancel',
  SEARCH_RESULT_CLICK = 'search::result_click',
  SEARCH_INPUT_CHANGED = 'search::input_changed',
  SEARCH_INPUT_FOCUSSED = 'search::input_focus',
  SEARCH_INPUT_BLURRED = 'search::input_blurred',
  SEARCH_RESET = 'search::reset',
}

export type SuccessPayload = SearchQuery & { searchedTerm: string };

export const Actions = {
  searchRequest: (payload: { query: string; page: number }) =>
    createAction(ActionTypes.SEARCH_REQUEST, payload),
  searchFetchStarted: (payload: { query: string; page: number }) =>
    createAction(ActionTypes.SEARCH_FETCH_STARTED, payload),
  searchSuccess: (data: SuccessPayload) =>
    createAction(ActionTypes.SEARCH_SUCCESS, data),
  searchFail: () => createAction(ActionTypes.SEARCH_FAIL),
  searchCancel: () => createAction(ActionTypes.SEARCH_CANCEL),
  searchResultClick: (articleId: string, title: string, index: number) =>
    createAction(ActionTypes.SEARCH_RESULT_CLICK, { articleId, title, index }),

  // Search Input
  searchTermChanged: (
    searchTerm: string,
    searchStyle: SearchStyle = SearchStyle.resultsPage
  ) =>
    createAction(ActionTypes.SEARCH_INPUT_CHANGED, { searchTerm, searchStyle }),

  // Search dropdown
  searchInputFocussed: () => createAction(ActionTypes.SEARCH_INPUT_FOCUSSED),
  searchInputBlurred: () => createAction(ActionTypes.SEARCH_INPUT_BLURRED),
  searchReset: () => createAction(ActionTypes.SEARCH_RESET),
};

export type Actions = ActionsUnion<typeof Actions>;
